<template>
  <div class="body">
    <div class="col column">
      <li style="padding-left:12px;padding-bottom:5px;">예측결과 [{{ formulas.length }}]</li>
      <div style="overflow:auto;display:flex;flex-direction:column;flex:1 0 0;padding:0px 25px;">
        <div v-if="formulas.length == 0" class="row" style="padding-top:5px;justify-content:center">
          <i>null</i>
        </div>
        <template v-else class="row" v-for="(formula, i) in formulas">
          <div :class="i == formulaIndex ? 'prediction-div-selected' : 'prediction-div'" :key="`prediction-${i}`" style="padding:5px 5px;cursor:pointer;" @click="listen__item__onclick(i)">
            <q-icon name="done" style="padding-right:5px;" />
            <b>{{ i + 1 }} :</b> {{ formula }}
          </div>
          <q-separator v-if="i < formulas.length - 1" :key="`prediction-sep-${i}`"/>
        </template>
      </div>
    </div>
    <div class="border row">
      <div style="flex:0 0 25px;" />
      <div class="col" style="background:rgb(100, 100, 100);height:1px;" />
      <div style="flex:0 0 25px;" />
    </div>
    <div class="col" style="overflow:auto;">
      <li style="padding-left:12px;padding-bottom:10px;">렌더링 [{{ formulas.length > 0 ? formulaIndex + 1 : '-' }}]</li>
      <vue-mathjax :formula="formula"></vue-mathjax>
    </div>
  </div>
</template>

<script>
import {VueMathjax} from 'vue-mathjax'

export default {
  props: ['formulas'],
  data: function () {
    return {
      // formula: '$$x = {-b \\pm \\sqrt{b^2-4ac} \\over 2a}+4+4+4+4+4+4+4+4+4++4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4$$'
      // formula: '$$x = {-b \\pm \\sqrt{b^2-4ac} \\over 2a}$$',
      formulaIndex: 0
    }
  },
  components: {
    'vue-mathjax': VueMathjax
  },
  methods: {
    'listen__item__onclick': function (i) {
      this.formulaIndex = i
    }
  },
  computed: {
    formula: function () {
      if (this.formulaIndex >= this.formulas.length)
        return '$$null$$'
      
      return `$$${this.formulas[this.formulaIndex]}$$`
    }
  },
  watch: {
    'formulas': function () {
      this.formulaIndex = 0
    }
  }
}
</script>

<style scoped>
.body {
  width: 100%;
  height: 100%;
  background: white;
  padding: 10px 0px;
  display:flex;
  flex-direction: column;
}
.border {
  height: 20px;
  align-items: center;
}

div.prediction-div-selected {
  color: red;
}

div.prediction-div-selected i {
  color:red;
}
div.prediction-div i {
  color:white
}

div.prediction-div:hover {
  background: rgb(230, 230, 230);
}
div.prediction-div:hover i {
  color: rgb(230, 230, 230);
}
</style>